var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"singleColumnWidth"},[_c('h2',[_vm._v("The GWTP Universe")]),(_vm.item != null)?_c('ViewItem',{attrs:{"item":_vm.item}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }